module.exports = __webpack_public_path__ + "resources/img/logo_partner_game_aceproject.39391b63e8f00b07deed736ad9c22a87.png";